export const getToken = state => state?.session?.token
export const getUserEmail = state => state?.session?.profile?.email
export const getActiveOrganisationId = state => state?.organisation?.active?.organisationId
export const getActiveOrganisation = state => state?.organisation?.active
export const getActiveAgentId = state => state?.agent?.active?.agentId
export const getActiveProjectId = state => state?.agent?.active?.projectId
export const getReportingConfig = state => state?.analyticsExport?.reportingConfig
export const getExportApiConfig = state => state?.analyticsExport?.exportApiConfig
export const getProdAgent = state => {
  const prodEnv = state?.project?.environments?.find(e => e.type === 'PROD')
  return state?.organisation?.active?.projects.find(p => p.agentId === prodEnv.agentId)
}
